import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DiscordBotService } from 'src/app/core/services/discord-bot.service';
import { GetBotResponse } from 'src/app/models/bot.interface';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'globot-discord-bot',
  templateUrl: './discord-bot.component.html',
  styleUrls: ['./discord-bot.component.scss'],
})
export class DiscordBotComponent implements OnInit {
  @Input() bot?: GetBotResponse;
  @Output() statusChange = new EventEmitter<{ status: string; style: { [key: string]: string } }>();

  serverId!: number;
  discordBot: FormGroup;
  channelNames: string[] = [];
  is_enabled: boolean = false;
  checked: boolean = false;
  serverName!: string;

  constructor(
    private fb: FormBuilder,
    private discordBotService: DiscordBotService,
    private ms: MessageService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.discordBot = this.fb.group({
      serverId: [{ value: '', disabled: false }, Validators.required],
      channelNames: [''],
      checked: [false],
      serverName: [''],
    });
  }

  ngOnInit(): void {
    this.discordBotService.getBotDiscord(this.bot!.id).subscribe({
      next: (response) => {
        this.serverId = response.data.server_id;
        this.is_enabled = response.data.is_enabled;
        this.checked = this.is_enabled;
        this.serverName = response.data.server_name;
        this.setStatus();

        if (response.data.channel_name) {
          this.channelNames = response.data.channel_name.split(',');
        } else {
          this.channelNames = [];
        }
        this.discordBot.patchValue({
          serverId: this.serverId,
          channelNames: this.channelNames,
          checked: this.is_enabled,
          serverName: this.serverName,
        });
      },
      error: (err) => {
        console.error('Hubo un error al obtener el server_id:', err);
        this.setStatus();
      },
    });
  }

  onSubmitServerId() {
    let server_id = this.discordBot.get('serverId')!.value;
    let server_name = this.discordBot.get('serverName')!.value;
    if (!server_id) {
      this.showMessage(
        'error',
        'Acción fallida',
        'Este campo es requerido para conectar tu asistente al servidor.'
      );
      return;
    }

    this.discordBot.patchValue({ serverId: server_id, serverName: server_name });

    if (this.bot?.id) {
      if (this.serverId) {
        this.updateDiscord(server_id, server_name);
      } else {
        this.postDiscord(server_id, server_name);
      }
    } else {
      this.showMessage('error', 'Acción fallida', 'El ID del servidor no es válido');
    }
    this.serverId = server_id;
    this.setStatus();
    this.changeDetectorRef.detectChanges();
  }

  updateDiscord(server_id: number, server_name: string) {
    this.discordBotService
      .updateBotDiscord(this.bot!.id, undefined!, server_id, undefined, server_name)
      .subscribe({
        next: (_response) => {
          this.showMessage('success', 'Acción exitosa', '¡ID del servidor actualizado!');
        },
        error: (_err) => {
          this.showMessage(
            'error',
            'Acción fallida',
            'ID ya asociado a otro chatbot. Ingrese un ID único y vuelva a intentarlo'
          );
        },
      });
  }

  postDiscord(server_id: number, server_name: string) {
    this.discordBotService
      .postBotDiscord(this.bot!.id, server_id, this.is_enabled || false, server_name)
      .subscribe({
        next: (_response) => {
          this.showMessage('success', 'Acción exitosa', '¡Bot de Discord agregado con éxito!');
        },
        error: (_err) => {
          this.showMessage(
            'error',
            'Acción fallida',
            'ID ya asociado a otro chatbot. Ingrese un ID único y vuelva a intentarlo.'
          );
        },
      });
  }

  showMessage(severity: string, summary: string, detail: string) {
    this.ms.add({ key: 'tst', severity: severity, summary: summary, detail: detail });
  }

  linkBot() {
    window.open(
      'https://discord.com/api/oauth2/authorize?client_id=1179412347153043527&permissions=8&scope=bot'
    );
  }
  onSubmitChannels() {
    this.channelNames = this.discordBot.get('channelNames')!.value;
    let channel_name = this.channelNames.join(',');

    this.discordBot.patchValue({ channelNames: [...this.channelNames] });

    this.discordBotService
      .updateBotDiscord(this.bot!.id, this.is_enabled || false, undefined, channel_name)
      .subscribe({
        next: (_response) => {
          this.ms.add({
            key: 'tst',
            severity: 'success',
            summary: 'Acción exitosa',
            detail: '¡Canales de Discord agregados con éxito!',
          });
        },
        error: (_err) => {
          this.ms.add({
            key: 'tst',
            severity: 'error',
            summary: 'Acción fallida',
            detail: 'Hubo un problema al actualizar los canales.',
          });
        },
      });
  }
  switchChanged(event: any) {
    this.checked = event.checked;
    this.discordBotService.updateBotDiscord(this.bot!.id, this.checked).subscribe({
      next: (_response) => {
        this.is_enabled = event.checked;
        this.setStatus();
        if (this.checked) {
          this.ms.add({
            key: 'tst',
            severity: 'success',
            summary: 'Acción exitosa',
            detail: '¡Discord Bot habilitado!',
          });
        } else {
          this.ms.add({
            key: 'tst',
            severity: 'success',
            summary: 'Acción exitosa',
            detail: '¡Discord Bot deshabilitado!',
          });
        }
      },
      error: (_err) => {
        this.ms.add({
          key: 'tst',
          severity: 'error',
          summary: 'Acción fallida',
          detail: 'Hubo un problema con el habilitado de tu Discord Bot.',
        });
      },
    });
  }
  enableInputs() {
    this.discordBot.get('serverId')?.enable();
  }
  setStatus() {
    let status;
    if (!this.serverId) {
      status = {
        status: 'Sin configurar',
        style: {
          'padding-left': '10px',
          'padding-right': '10px',
          background: '#EDEDED',
          color: '#6B6B6B',
        },
      };
    } else if (this.is_enabled) {
      status = {
        status: 'Activo',
        style: {
          'padding-left': '10px',
          'padding-right': '10px',
          background: '#BBF7D0',
          color: '#16A34A',
        },
      };
    } else {
      status = {
        status: 'Inactivo',
        style: {
          'padding-left': '10px',
          'padding-right': '10px',
          background: '#FFF9CE',
          color: '#E0A53E',
        },
      };
    }
    this.statusChange.emit(status);
  }
}
